/* Orsa — Events (date/time UI + CTA states) */
(function () {
  // Injected from sections/orsa-events.liquid via window.orsaEventsI18n
  var I18N = {};
  var IS_EN = true;
  var INTL_LOCALE = "en-US";

  function refreshLocale() {
    I18N = window.orsaEventsI18n || {};
    var loc = I18N.locale || document.documentElement.lang || "en";
    IS_EN = /^en\b/i.test(loc);
    // English keeps the original en-US formatting; every other locale formats natively
    // (Danish -> 24h "17.30", localized month names, no ordinal suffix).
    INTL_LOCALE = IS_EN ? "en-US" : loc;
  }

  function daySuffix(day) {
    if (day >= 11 && day <= 13) return "th";
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

  function formatTime(d) {
    if (IS_EN) {
      return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).toLowerCase();
    }
    return d.toLocaleTimeString(INTL_LOCALE, { hour: "2-digit", minute: "2-digit", hour12: false });
  }

  function formatDateParts(d) {
    var month = d.toLocaleString(INTL_LOCALE, { month: "short" });
    var day = d.getDate();
    var year = d.getFullYear();
    return { month: month, day: day, year: year };
  }

  function parseDateInput(dateRaw) {
    var s = (dateRaw || "").trim();
    if (!s) return null;

    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      var ymd = s.split("-");
      return { y: +ymd[0], m: +ymd[1], d: +ymd[2] };
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(s)) {
      var dmy = s.split("-");
      return { y: +dmy[2], m: +dmy[1], d: +dmy[0] };
    }

    return null;
  }

  function toDateObj(parts, timeRaw) {
    if (!parts) return null;

    var time = /^\d{2}:\d{2}$/.test((timeRaw || "").trim()) ? timeRaw.trim() : "00:00";
    var mm = String(parts.m).padStart(2, "0");
    var dd = String(parts.d).padStart(2, "0");

    var iso = parts.y + "-" + mm + "-" + dd + "T" + time + ":00";
    var d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;

    return d;
  }

  function renderComingSoon(dateEl) {
    if (!dateEl) return;
    var label = I18N.comingSoon || "Coming soon";
    dateEl.innerHTML =
      '<div class="orsa-event__date-line">' + label + "</div>" +
      '<div class="orsa-event__year">&nbsp;</div>';
  }

  function init(root) {
    refreshLocale();

    var scope = root && root.querySelector ? root : document;
    var wraps = scope.querySelectorAll("[data-orsa-events]");
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      var items = wrap.querySelectorAll("[data-event]");
      var now = Date.now();

      items.forEach(function (card) {
        var mode = (card.getAttribute("data-cta-mode") || "").trim();
        var dateRaw = (card.getAttribute("data-date") || "").trim();
        var timeRaw = (card.getAttribute("data-time") || "").trim();

        var dateEl = card.querySelector("[data-date-ui]");
        var timeEl = card.querySelector("[data-time-ui]");
        var cta = card.querySelector("[data-cta]");

        if (mode === "coming_soon") {
          renderComingSoon(dateEl);
          if (timeEl) timeEl.textContent = "";
          if (cta) {
            cta.textContent = "";
            cta.setAttribute("aria-hidden", "true");
          }
          card.classList.add("is-coming-soon");
          return;
        }

        var parsed = parseDateInput(dateRaw);
        var d = toDateObj(parsed, timeRaw);
        if (!d) return;

        var parts = formatDateParts(d);

        if (dateEl) {
          var suffix = IS_EN
            ? '<span class="orsa-event__date-suffix">' + daySuffix(parts.day) + "</span>"
            : "";
          dateEl.innerHTML =
            '<div class="orsa-event__date-line">' +
              parts.month + " " + parts.day + suffix +
            "</div>" +
            '<div class="orsa-event__year">' + parts.year + "</div>";
        }

        if (timeEl) timeEl.textContent = formatTime(d);

        if (d.getTime() < now) {
          card.classList.add("is-past");
          card.setAttribute("aria-disabled", "true");

          if (card.tagName === "A") {
            card.removeAttribute("href");
            card.removeAttribute("target");
            card.removeAttribute("rel");
          }

          if (cta) cta.textContent = I18N.done || "Done";
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () { init(document); });
  document.addEventListener("shopify:section:load", function (e) {
    init(e && e.target ? e.target : document);
  });
})();